import { PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'

import { UnitsCard } from '../components'

export const UnitsPage = () => {
  const { t } = useLocales()

  return (
    <PageBreadcrumbs
      items={[
        {
          title: t('menu.medicines_register')
        },
        {
          title: t('medicine_register.units.title')
        }
      ]}
      title={t('medicine_register.units.title')}
    >
      <UnitsCard />
    </PageBreadcrumbs>
  )
}
